export const scrollActiveInputIntoView = (): void => {
  const activeElement = document.activeElement as HTMLElement | null;
  if (!activeElement) return;

  const tag = activeElement.tagName;
  if (tag !== 'INPUT' && tag !== 'TEXTAREA') return;

  const offsetPx = 28;

  // Find the nearest scrollable ancestor
  let scrollParent: HTMLElement | null = activeElement.parentElement;
  while (scrollParent) {
    const style = getComputedStyle(scrollParent);
    const canScrollY = /(auto|scroll)/.test(style.overflowY);
    if (canScrollY) break;
    scrollParent = scrollParent.parentElement;
  }

  if (!scrollParent) return; // no scrollable parent (maybe window)

  // Compute how far to scroll
  const parentRect = scrollParent.getBoundingClientRect();
  const wrapperRect = activeElement.getBoundingClientRect();

  const scrollTop = scrollParent.scrollTop + (wrapperRect.top - parentRect.top) - offsetPx;

  // Scroll smoothly
  scrollParent.scrollTo({
    top: scrollTop,
    behavior: 'smooth',
  });
};
